export default __webpack_public_path__ + "static/media/tech.e8413b38.jpg";